import { lazy } from 'react'
import lazyComponent from './lazy'

const Profile = lazy(() => import('../containers/Profile'))

// Account navigation lives in the user dropdown, outside the business sidebar.
const states = [{
  key: 'view_profile',
  url: 'mi-perfil',
  name: 'App.Profile',
  title: 'Mi perfil',
  views: { 'main@App': lazyComponent(Profile) },
}]

export default states
